import React from 'react';
import './PageStyles.css';

const Knowledgebase = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Knowledgebase</h1>
        <p className="page-subtitle">Manage medical knowledge and documents</p>

        <div className="placeholder-content">
          <div className="placeholder-icon">📚</div>
          <p>Knowledgebase management page - Coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default Knowledgebase;
